(function(){
    'use strict';

    angular
    .module('app')
    .controller('MultiselectconfigController', MultiselectconfigController)
 
    MultiselectconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function MultiselectconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.nodetype = "";
        vm.field = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

			

            j.references["nodeType"] = vm.nodetype;
            j.references["field"] = vm.field;

			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		vm.sizes = vm.json.references.sizes;
        	}
        	vm.update();
        	$(document).on("change","#nodeType,#fieldnodetype",function(){
				vm.update();
			});
        }

    } 

})();